<div>
  <select class="browser-default custom-select" id="services" (change)="changeOptionSelect();">
    <option value="{{LOCAL_CNN}}" [selected]="faceRecognitionService.emotionServiceUrl === LOCAL_CNN">Locally CNN
    </option>
      <option value="{{CNN_PATH}}" disabled [selected]="faceRecognitionService.emotionServiceUrl === CNN_PATH">Emotion
          Api 1 (CNN)
    </option>
      <option value="{{BOVW_PATH}}" disabled [selected]="faceRecognitionService.emotionServiceUrl === BOVW_PATH">Emotion
          Api 2
      (BOVW)
    </option>
  </select>
</div>
<hr/>
<div *ngIf="!faceRecognitionService.classifiersLoadFinished">
  <div class="loader">
  </div>
</div>
<div class="text-center justify-content-around">
  <pre style="font-size: smaller;font-weight: bold;"><span
    style="color:#FAAF13">{{emotionService.emotionalLocalMsgAngry}}</span>
<span style="color:#583342">{{emotionService.emotionalLocalMsgDisgust}}</span>
<span style="color:#7C8B30">{{emotionService.emotionalLocalMsgFear}}</span>
<span style="color:#A72229">{{emotionService.emotionalLocalMsgHappy}}</span>
<span style="color:#292148">{{emotionService.emotionalLocalMsgNeutral}}</span>
<span style="color:#504F4F">{{emotionService.emotionalLocalMsgSad}}</span>
<span style="color:#0475C0">{{emotionService.emotionalLocalMsgSurprise}}</span>
<span style="color:#D74407">{{emotionService.emotionalLocalMsgContemptuous}}</span></pre>
</div>
<hr/>
<div class="text-center">
  <h6 for="fpsOpenCV">FPS ({{faceRecognitionService.fps}})</h6>
  <input type="range" id="fps" name="fps" [(ngModel)]="faceRecognitionService.fps"
         min="1" max="30" step="1" value="{{faceRecognitionService.fps}}">
</div>
